import api from './api';
import { LoginForm, Usuario } from '../types';

// Tipo para la respuesta de login del backend
interface LoginResponse {
  token: string;
  usuario: Usuario;
  expiresAt: string;
}

export const authService = {
  async login(credentials: LoginForm): Promise<LoginResponse> {
    const response = await api.post('/auth/login', credentials);
    return response.data;
  },

  async getCurrentUser(): Promise<Usuario> {
    const response = await api.get('/auth/me');
    return response.data;
  },

  async logout(): Promise<void> {
    await api.post('/auth/logout', {});
  },

  async forgotPassword(email: string): Promise<{ message: string }> {
    const response = await api.post('/auth/forgot-password', { email });
    return response.data;
  },

  async resetPassword(email: string, newPassword: string): Promise<{ message: string }> {
    const response = await api.post('/auth/reset-password', { email, newPassword });
    return response.data;
  },
}; 